import { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'

import searchTour from 'entities/tour/models/search-tour/search-tour'
import {
  DirectionCard,
  DirectionCardSkeleton,
} from 'entities/tour/ui/direction-card'

import { SearchToursApi, TourDepartureCity } from 'shared/api/tours/search'
import GlassImage from 'shared/images/glasss.png'
import { EmptyPage } from 'shared/ui/empty-page'
import { HeaderGoBack } from 'shared/ui/header-go-back'

import s from './styles.module.scss'

const DeparturePage = () => {
  const navigate = useNavigate()

  const { t } = useTranslation()
  const [loading, setLoading] = useState<boolean>(false)
  const [cities, setCities] = useState<TourDepartureCity[]>([])

  const onClickDirection = (city: TourDepartureCity) => {
    searchTour.setDeparture(city)

    navigate(-1)
  }

  const getCities = async () => {
    setLoading(true)
    try {
      const response = await SearchToursApi.getDepartureCities()

      setCities(response?.data?.data)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    void getCities()
  }, [])

  return (
    <div className="container">
      <HeaderGoBack
        buttonWhite
        title={t('tours_block.from')}
        variant="grey"
      />

      <div className={s.wrapper}>
        <p className={clsx('bold-20', s.directionTitle)}>{t('cities')}</p>

        {loading ? (
          Array.from({ length: 3 }).map(() => <DirectionCardSkeleton />)
        ) : !!cities.length ? (
          cities.map((item) => (
            <DirectionCard
              key={item.id}
              destination={item}
              onClick={() => onClickDirection(item)}
            />
          ))
        ) : (
          <EmptyPage
            image={GlassImage}
            title={t('empty')}
            subTitle={t('tours_block.empty_desc')}
          />
        )}
      </div>
    </div>
  )
}

export default DeparturePage
